export const QUARTERLY_LABEL = 'Q';
const MONTH_DAYS_THRESHOLD = 15;

interface MonthlyLabelParams {
  startDate: Date;
  endDate: Date;
  startMonthLabel: string;
  endMonthLabel: string;
  startYearLabel: string;
  endYearLabel: string;
}
const getMonthlyLabel = (params: MonthlyLabelParams): string => {
  const { startDate, endDate, startMonthLabel, endMonthLabel, startYearLabel, endYearLabel } = params;
  if (startDate.getMonth() === endDate.getMonth()) {
    return `${startMonthLabel} '${startYearLabel}`;
  }

  // Calculate the number of days in the start and end month to see if it is greater than the threshold.
  const numDaysInStartMonth =
    new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() - startDate.getDate() + 1;
  const numDaysInEndMonth = endDate.getDate();
  if (numDaysInStartMonth >= MONTH_DAYS_THRESHOLD && numDaysInEndMonth >= MONTH_DAYS_THRESHOLD) {
    return `${startMonthLabel} '${startYearLabel} - ${endMonthLabel} '${endYearLabel}`;
  }
  if (numDaysInStartMonth >= MONTH_DAYS_THRESHOLD) {
    return `${startMonthLabel} '${startYearLabel}`;
  }
  if (numDaysInEndMonth >= MONTH_DAYS_THRESHOLD) {
    return `${endMonthLabel} '${endYearLabel}`;
  }
  return `${startMonthLabel} '${startYearLabel}`;
};

/**
 * Returns the label for the line chart based on the start and end date.
 */
// eslint-disable-next-line max-statements
export const getLineChartQuarterOrMonthLabel = (startDateStr: string, endDateStr: string): string => {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();

  const startMonthLabel = startDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const endMonthLabel = endDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const startYearLabel = startDate.getFullYear().toString().slice(-2);
  const endYearLabel = endDate.getFullYear().toString().slice(-2);

  const isMonthly = endMonth - startMonth <= 1;
  if (isMonthly) {
    return getMonthlyLabel({ startDate, endDate, startMonthLabel, endMonthLabel, startYearLabel, endYearLabel });
  }
  const startQuarter = Math.ceil((startMonth + 1) / 3);
  const endQuarter = Math.ceil((endMonth + 1) / 3);

  const isQuarterly = startQuarter === endQuarter && endMonth - startMonth === 2;
  if (isQuarterly) {
    return `${QUARTERLY_LABEL}${startQuarter} '${startYearLabel}`;
  }
  return `${startMonthLabel} '${startYearLabel} - ${endMonthLabel} '${endYearLabel}`;
};
